export default __webpack_public_path__ + "static/media/pulling-details-loading.f4aed045.gif";